import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, Renderer2, PLATFORM_ID } from "@angular/core";
import { environment } from '../environments/environment';

declare let window: any

@Injectable({
	providedIn: 'root'
})
export class FacebookPixelModel {
    isDev: boolean = true;
    constructor(@Inject(DOCUMENT) private _document: Document, @Inject(PLATFORM_ID) private platformId: Object) {
        if(environment.production) {
            this.isDev = false;
        }
    }

    checkIfExistsIdAndRemove(renderer: any, pixelIds: (string | number)[]) {
      pixelIds.forEach(pixelId => {
        const srcScript = this._document.querySelector('script[src*='+'"'+pixelId+'"'+']');
        srcScript ? renderer.removeChild('head', srcScript) : false;
      });
    }

    setGetinPixel(renderer: any, trackPurchase: boolean, currency: String = '', producerCredit: number = 0, trackExtra: string = undefined, contents: string = '') {
        let pixelId = [1760804754175718];
        this.removeOldPixels(renderer,  'fbq', pixelId);
        this.setPixel(renderer, pixelId, trackPurchase, currency, producerCredit, trackExtra, contents);
    }

    checkIfPixelsInit(pixel) {
      const promise = new Promise((resolve) => {
        setTimeout(() => {
          const hasScript = this._document.getElementsByClassName(pixel);
          resolve(!!(hasScript && hasScript.length));
        }, 0);
      });
      return promise;
    }

    removeOldPixels(renderer: Renderer2, pixelType: string, pixelIds: (string | number)[]) {
      const pixels = this._document.getElementsByClassName(pixelType+'-'+'pixel-event');
      const pixelArray = Array.prototype.slice.call(<any>pixels);
        pixelArray.forEach(element => {
          renderer.removeChild('body',element);
          renderer.removeChild('head',element);
        });
    }

    async setPixel(renderer: any, pixelIds: (string | number)[], trackPurchase: boolean, currency: String = '', producerCredit: number = 0, trackExtra: string = undefined, contents: any = '') {
        if(this.isDev) {
            return;
        }
        const getinPixelId = 1760804754175718;
        let pixels = "fbq('init', '"+getinPixelId+"');";
        pixelIds.forEach(pixelId => {
          String(pixelId) !== String(getinPixelId) ? pixels += "fbq('init', '"+pixelId+"');" : false;
        });
        // console.log('All pixels that will be init', pixels);
        const pixelIsInit = await this.checkIfPixelsInit('fbq-init');
        // 'trackSingle', 'trackSingleCustom'
        let trackAction = (trackPurchase) ? "fbq('trackCustom', 'Purchase', {currency: \""+currency+"\", value: "+producerCredit+"});" : (trackExtra) ? "fbq('trackCustom', '"+trackExtra+"');" : "";
        contents ? trackAction = (trackPurchase) ? "fbq('trackCustom', 'Purchase', {currency: \""+currency+"\", value: "+producerCredit+","+contents+"});" : (trackExtra) ? "fbq('trackCustom', '"+trackExtra+"', {"+contents+"});" : "" : (trackPurchase) ? "fbq('trackCustom', 'Purchase', {currency: \""+currency+"\", value: "+producerCredit+"});" : (trackExtra) ? "fbq('trackCustom', '"+trackExtra+"');" : "";
        // console.log('Check Pixel events: ', trackAction, pixelIsInit, trackPurchase, trackExtra, contents); // contents: "+contents+"
        if (!pixelIsInit || (isPlatformBrowser(this.platformId) && !window.fbq)) {
        let fb_pixel = renderer.createElement('script');
        renderer.addClass(fb_pixel, 'fbq-init');
        fb_pixel.type = 'text/javascript';
        fb_pixel.text =
        `
          !function(f,b,e,v,n,t,s){
            if(f.fbq)return;n=f.fbq=function(){
              n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)
            };
            if(!f._fbq)f._fbq=n;
            n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
            t=b.createElement(e);t.async=!0;t.src=v;
            s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)
          }
          (window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
          `+pixels+`
        `;

        setTimeout(()=>{
          // console.log('pixelIsNotInit', pixelIsInit);
          if (trackAction) {
              let fb_trackAction = renderer.createElement('script');
              fb_trackAction.type = 'text/javascript';
              fb_trackAction.text = trackAction;
              renderer.addClass(fb_trackAction, 'fbq-'+'pixel-event');
              renderer.appendChild(this._document.body, fb_trackAction);
              // console.log('setPixel trackAction: ', pixelIds, trackAction);
          }
        }, 200);


        renderer.insertBefore(this._document.head, fb_pixel, this._document.head.lastChild);
      } else {
        if (trackAction) {
            let fb_trackAction = renderer.createElement('script');
            fb_trackAction.type = 'text/javascript';
            fb_trackAction.text = trackAction;
            renderer.addClass(fb_trackAction, 'fbq-'+'pixel-event');
            renderer.appendChild(this._document.body, fb_trackAction);
        }
      }
      setTimeout(() => {
        this.removeOldPixels(renderer, 'fbq', pixelIds);
      }, 200);
    }

    removePurchaseTag(renderer: any, pixelIds: (string | number)[], trackExtra: string = undefined) {
        this.removeOldPixels(renderer, 'fbq', pixelIds);
    }

    removeGetinPurchaseTag(renderer: any, trackExtra: string = undefined) {
        let pixelId = [1760804754175718];
        this.removePurchaseTag(renderer, pixelId, trackExtra);
    }
    removeGetinPixel(renderer: any) {
        let pixelId = [1760804754175718];
        this.removeOldPixels(renderer, 'fbq', pixelId);
        this.checkIfExistsIdAndRemove(renderer, pixelId);
    }
    removePixelInit(renderer: Renderer2, pixel = null) {
      const initPixel = 'fbq-init';
      const hasScript = this._document.getElementsByClassName(initPixel).item(0);
      if (hasScript) {
        renderer.removeChild('body',hasScript);
        renderer.removeChild('head',hasScript);
      }
      if (isPlatformBrowser(this.platformId) && window.fbq) {
        window.fbq = window._fbq = null;
      }
    }
}
